<template>
  <div class="text-center">
    <template v-if="extra.included === 'Y'">
      <v-icon
        large
        color="primary"
        class="mb-1"
      >
        mdi-check
      </v-icon>
      <p
        v-if="extra.cover"
        class="caption
        font-weight-medium
        mb-0"
      >
        <span>
          &pound;{{ extraCoverValue }}
        </span>
      </p>
      <span class="fs-10 mb-0">
        Excess: &pound;{{ extra.excess ? extra.excess.toLocaleString() : 0 }}
      </span>
    </template>

    <template v-if="extra.included === 'extra'">
      <v-fade-transition hide-on-leave>
        <div v-if="!selected">
          <div v-if="extra.cover === null">
            <p class="caption font-weight-medium mb-0 has-icon-indent">
              Check with provider
            </p>
          </div>

          <template v-else>
            <v-icon
              large
              color="primary"
              class="mb-1"
            >
              mdi-plus
            </v-icon>

            <div>
              <p class="caption font-weight-medium mb-0">
                Available
              </p>
              <p
                v-if="extra.cover"
                class="fs-10 mb-0"
              >
                <span>from</span>
                <span class="font-weight-medium">
                  &pound;{{ extraCoverValue }}
                </span>
              </p>

              <p
                v-else
                class="fs-10 mb-0"
              >
                check with provider
              </p>
            </div>
          </template>
        </div>
      </v-fade-transition>

      <v-fade-transition hide-on-leave>
        <div v-if="selected">
          <div v-if="extra.cover === null">
            <p class="caption font-weight-medium mb-0 has-icon-indent">
              Check with provider
            </p>
          </div>

          <template v-else>
            <v-icon
              large
              :color="extra.cover && extra.cover ? 'accent' : 'primary'"
              class="mb-1"
            >
              mdi-check
            </v-icon>

            <div>
              <template v-if="extra.cover">
                <p class="caption font-weight-medium mb-0">
                  Added
                </p>
                <p class="fs-10 mb-0">
                  at
                  <span class="font-weight-medium">
                    &pound;{{ extraCoverValue }}
                  </span>
                </p>
              </template>

              <template v-else>
                <p class="caption font-weight-medium mb-0">
                  Available
                </p>
                <p class="fs-10 mb-0">
                  check with provider
                </p>
              </template>
            </div>
          </template>
        </div>
      </v-fade-transition>
    </template>

    <template v-if="!extra.included || extra.included === 'N'">
      <v-icon
        large
        color="navy-dark"
        class="mb-1"
      >
        mdi-close
      </v-icon>
      <p class="caption font-weight-medium text-break mb-0">
        Not Available
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'results-optional-extra',
  inject: ['constants'],
  props: {
    extra: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    extraCoverValue () {
      return this.extra?.cover >= this.constants.OPTIONAL_EXTRA_COVER_MAX ? `${this.extra.cover / this.constants.OPTIONAL_EXTRA_COVER_MAX}m`
        : this.extra?.cover.toLocaleString();
    },
  },
};
</script>

<style lang='scss'>
.has-icon-indent {
  margin-top: var(--fz, 28px);
}
</style>
